/* BayrakEvim teması — Shopify
   Bölüm karşılıkları theme.css içinde yorumlanmıştır. */
(function () {
  'use strict';

  var C = window.BE || {};
  var paraBicimi = C.para || '{{amount}} TL';

  function para(kurus) {
    var n = (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return paraBicimi.replace(/\{\{\s*amount[^}]*\}\}/, n);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Sepet çekmecesi ---------------- */
  function sepetAc(ac) {
    var d = document.getElementById('sepet-drawer'), p = document.getElementById('sepet-perde');
    if (!d) return;
    d.classList.toggle('acik', ac);
    if (p) p.classList.toggle('acik', ac);
    document.body.style.overflow = ac ? 'hidden' : '';
  }

  function sepetCiz(sepet) {
    var liste = document.getElementById('sepet-liste');
    document.querySelectorAll('[data-sepet-adet]').forEach(function (e) { e.textContent = sepet.item_count; });
    var toplam = document.getElementById('sepet-toplam');
    if (toplam) toplam.textContent = para(sepet.total_price);
    if (!liste) return;
    if (!sepet.items || !sepet.items.length) {
      liste.innerHTML = '<div class="bo-sepet__bos">Sepetinizde ürün bulunmuyor.<br><br>' +
        'Kaput bayraklarını inceleyip aracınıza özel sipariş oluşturabilirsiniz.</div>';
      return;
    }
    liste.innerHTML = sepet.items.map(function (it, i) {
      var ozel = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (it.properties[k]) ozel += '<em>' + esc(k) + ': ' + esc(it.properties[k]) + '</em>';
        });
      }
      return '<div class="bo-sepet__satir">' +
        (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '') +
        '<div style="flex:1;min-width:0">' +
        '<strong>' + esc(it.product_title) + '</strong>' + ozel +
        '<em>' + it.quantity + ' adet</em>' +
        '<b>' + para(it.final_line_price) + '</b>' +
        '<button class="bo-sepet__sil" data-sil="' + (i + 1) + '">Kaldır</button>' +
        '</div></div>';
    }).join('');
  }

  function sepetGetir(ac) {
    return fetch(C.rotaSepet + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { sepetCiz(s); if (ac) sepetAc(true); return s; });
  }

  function satirDegistir(satir, adet) {
    return fetch(C.rotaDegistir + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: satir, quantity: adet })
    }).then(function (r) { return r.json(); }).then(function (s) { sepetCiz(s); return s; });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sepet-ac]')) { e.preventDefault(); sepetGetir(true); }
    if (e.target.closest('[data-sepet-kapat]') || e.target.id === 'sepet-perde') sepetAc(false);
    var sil = e.target.closest('[data-sil]');
    if (sil) { e.preventDefault(); satirDegistir(+sil.getAttribute('data-sil'), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sepetAc(false); });

  /* ---------------- Geri sayım ---------------- */
  (function () {
    var el = document.querySelector('[data-sayac-s],[data-sayac-tam]');
    if (!el) return;
    var saat = 6;
    saat = +document.body.getAttribute('data-sayac-saat') || 6;
    var bitis = Date.now() + saat * 3600 * 1000;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tik() {
      var s = Math.max(0, Math.floor((bitis - Date.now()) / 1000));
      var h = pad(Math.floor(s / 3600)), m = pad(Math.floor((s % 3600) / 60)), sn = pad(s % 60);
      document.querySelectorAll('[data-sayac-s]').forEach(function (e) { e.textContent = h; });
      document.querySelectorAll('[data-sayac-m]').forEach(function (e) { e.textContent = m; });
      document.querySelectorAll('[data-sayac-sn]').forEach(function (e) { e.textContent = sn; });
      document.querySelectorAll('[data-sayac-tam]').forEach(function (e) { e.textContent = h + ':' + m + ':' + sn; });
    }
    tik(); setInterval(tik, 1000);
  })();

  /* ---------------- Katalog filtresi ---------------- */
  (function () {
    var btnler = document.querySelectorAll('[data-filtre]');
    if (!btnler.length) return;
    btnler.forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-filtre'), gorunen = 0;
        btnler.forEach(function (x) { x.classList.toggle('aktif', x === b); });
        document.querySelectorAll('[data-grup]').forEach(function (k) {
          var ok = (g === 'hepsi' || k.getAttribute('data-grup') === g);
          k.style.display = ok ? '' : 'none';
          if (ok) gorunen++;
        });
        var bos = document.getElementById('katalog-bos');
        if (bos) bos.style.display = gorunen ? 'none' : 'block';
        var say = document.getElementById('katalog-sayi');
        if (say) say.textContent = gorunen;
      });
    });
  })();

  /* ---------------- Ürün galerisi ---------------- */
  document.querySelectorAll('.mk-urun__galeri').forEach(function (kok) {
    var vp = kok.querySelector('.mk-urun__vp'), track = kok.querySelector('.mk-urun__track');
    if (!vp || !track) return;
    var n = track.children.length;
    if (n < 2) { kok.querySelectorAll('.mk-urun__ok').forEach(function (o) { o.style.display = 'none'; }); return; }
    var pos = 0, timer = null, noktaKap = kok.querySelector('.mk-urun__nokta'), noktalar = [];
    if (noktaKap) {
      for (var i = 0; i < n; i++) (function (k) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', (k + 1) + '. görsel');
        b.addEventListener('click', function () { git(k); basla(); });
        noktaKap.appendChild(b); noktalar.push(b);
      })(i);
    }
    function ciz() {
      track.style.transform = 'translateX(' + (-pos * 100) + '%)';
      noktalar.forEach(function (d, j) { d.classList.toggle('mk-aktif', j === pos); });
    }
    function git(k) { pos = (k + n) % n; ciz(); }
    function ileri() { git(pos + 1); }
    function geri() { git(pos - 1); }
    var sol = kok.querySelector('.mk-urun__ok--sol'), sag = kok.querySelector('.mk-urun__ok--sag');
    if (sol) sol.addEventListener('click', function () { geri(); basla(); });
    if (sag) sag.addEventListener('click', function () { ileri(); basla(); });
    function basla() { durdur(); timer = setInterval(ileri, 4500); }
    function durdur() { if (timer) { clearInterval(timer); timer = null; } }
    var sx = 0, suruk = false;
    vp.addEventListener('pointerdown', function (e) { suruk = true; sx = e.clientX; durdur(); });
    window.addEventListener('pointerup', function (e) {
      if (!suruk) return; suruk = false;
      var dx = e.clientX - sx;
      if (dx < -40) ileri(); else if (dx > 40) geri();
      basla();
    });
    vp.addEventListener('mouseenter', durdur);
    vp.addEventListener('mouseleave', basla);
    ciz(); basla();
  });

  /* ---------------- Ürün formu ---------------- */
  (function () {
    var form = document.getElementById('urun-form');
    if (!form) return;
    var arac = document.getElementById('arac-modeli');
    var kutu = document.getElementById('arac-kutu');
    var adetIn = document.getElementById('urun-adet');

    document.querySelectorAll('[data-adet]').forEach(function (b) {
      b.addEventListener('click', function () {
        adetIn.value = Math.max(1, Math.min(20, (+adetIn.value || 1) + (+b.getAttribute('data-adet'))));
      });
    });

    function dogrula() {
      if (!arac) return true;
      if (!arac.value.trim()) {
        kutu.classList.add('hata');
        arac.focus();
        kutu.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      kutu.classList.remove('hata');
      return true;
    }
    if (arac) arac.addEventListener('input', function () { if (arac.value.trim()) kutu.classList.remove('hata'); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!dogrula()) return;
      var btn = form.querySelector('[name="add"]');
      var eskiMetin = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ekleniyor…'; }
      fetch(C.rotaEkle + '.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sepete eklenemedi');
          return sepetGetir(true);
        })
        .catch(function (err) { alert(err.message); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = eskiMetin; } });
    });

    var wa = document.getElementById('wa-siparis');
    if (wa && C.wa) {
      wa.addEventListener('click', function () {
        if (!dogrula()) return;
        var baslik = (document.querySelector('.mk-urun__box h1') || {}).textContent || '';
        var msg = 'Merhaba, sipariş vermek istiyorum.\n\nÜrün: ' + baslik.trim() +
          '\nAdet: ' + (adetIn ? adetIn.value : 1) +
          (arac ? '\nAracım: ' + arac.value.trim() : '') +
          '\n\n' + location.href;
        window.open('https://wa.me/' + C.wa + '?text=' + encodeURIComponent(msg), '_blank');
      });
    }
  })();

  /* ---------------- Sepet sayfası adet butonları ---------------- */
  document.querySelectorAll('[data-satir-adet]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = b.getAttribute('data-index');
      var inp = document.querySelector('input[name="updates[]"][data-index="' + i + '"]');
      if (!inp) return;
      var yeni = Math.max(0, (+inp.value || 0) + (+b.getAttribute('data-satir-adet')));
      inp.value = yeni;
      satirDegistir(+i, yeni).then(function () { location.reload(); });
    });
  });

  /* ---------------- Yapışkan alt bar ---------------- */
  (function () {
    var altbar = document.getElementById('altbar');
    if (!altbar) return;
    window.addEventListener('scroll', function () {
      altbar.classList.toggle('gorunur', window.scrollY > 480);
    }, { passive: true });
    var esik = document.getElementById('altbar-esik');
    if (esik && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (gs) {
        gs.forEach(function (g) { altbar.classList.toggle('nio-altbar--gizli', g.isIntersecting); });
      }, { rootMargin: '0px 0px -18% 0px' }).observe(esik);
    }
    var hedef = document.getElementById('altbar-hedef');
    if (hedef) hedef.addEventListener('click', function () {
      var t = document.getElementById('satin-al') || document.getElementById('katalog');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else location.href = '/collections/all';
    });
  })();

  /* ---------------- Video duvarı ---------------- */
  (function () {
    var kartlar = document.querySelectorAll('.bo-vid');
    if (!kartlar.length) return;
    function durdur(haric) {
      kartlar.forEach(function (k) {
        var v = k.querySelector('video');
        if (v && v !== haric) { v.pause(); k.classList.remove('bo-vid--oynuyor'); }
      });
    }
    kartlar.forEach(function (k) {
      var cerceve = k.querySelector('.bo-vid__cerceve');
      var v = k.querySelector('video');
      if (!cerceve || !v) return;
      cerceve.addEventListener('click', function () {
        if (v.paused) {
          durdur(v);
          v.muted = false; v.controls = true;
          v.play().catch(function () { v.muted = true; v.play(); });
        } else { v.pause(); }
      });
      v.addEventListener('play', function () { k.classList.add('bo-vid--oynuyor'); });
      v.addEventListener('pause', function () { k.classList.remove('bo-vid--oynuyor'); });
    });
    var daha = document.getElementById('vid-daha');
    if (daha) daha.addEventListener('click', function () {
      document.querySelectorAll('.bo-vid--gizli').forEach(function (k) { k.classList.remove('bo-vid--gizli'); });
      daha.remove();
    });
  })();

  /* ---------------- Çerez banner ---------------- */
  (function () {
    var cerez = document.getElementById('cerez');
    if (!cerez) return;
    var panel = cerez.querySelector('[data-panel]');
    var ANAHTAR = 'be_cerez';
    var kayitli = null;
    try { kayitli = localStorage.getItem(ANAHTAR); } catch (e) {}
    if (!kayitli) cerez.removeAttribute('hidden');

    function izinVer(analytics, marketing) {
      try { localStorage.setItem(ANAHTAR, JSON.stringify({ a: analytics, m: marketing })); } catch (e) {}
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent(
          { analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: marketing },
          function () {}
        );
      }
      cerez.setAttribute('hidden', '');
    }

    cerez.addEventListener('click', function (e) {
      var d = e.target.closest('[data-cerez]');
      if (!d) return;
      var a = d.getAttribute('data-cerez');
      if (a === 'ayar') { panel.removeAttribute('hidden'); return; }
      if (a === 'kabul') return izinVer(true, true);
      if (a === 'red') return izinVer(false, false);
      if (a === 'kaydet') {
        var an = cerez.querySelector('[data-izin="analytics"]');
        var mk = cerez.querySelector('[data-izin="marketing"]');
        return izinVer(!!(an && an.checked), !!(mk && mk.checked));
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cerez-ac]')) {
        e.preventDefault();
        cerez.removeAttribute('hidden');
        panel.removeAttribute('hidden');
      }
    });
  })();

  /* ---------------- Canlı izleyici efekti ---------------- */
  document.querySelectorAll('[data-izleyen]').forEach(function (el) {
    var v = +el.textContent || 40;
    setInterval(function () {
      v = Math.max(23, Math.min(94, v + (Math.random() < 0.5 ? -1 : 1) * Math.ceil(Math.random() * 3)));
      el.textContent = v;
    }, 4200);
  });

  /* ilk yüklemede sepet rozetini tazele */
  if (document.getElementById('sepet-liste')) sepetGetir(false);
})();
